import SalesHistory from './SalesHistory';
export default SalesHistory;
